import React from "react";
import CompanyInfoPanelComponent from "./companyInfoPanel.component";

export default function CompanyInfoPanelContainer() {
  return (
    <CompanyInfoPanelComponent/>
  )
}